import intl from 'react-intl-universal'

export default {
  type: 'video',
  title: `Video`,
  icon: `video-camera`,
  interfaceApi: '/videocenter/plugins/videosearch/',
  template: `<figure class="feature-wrapper" contenteditable="false" data-vid-desc="{{feature.description.basic}}" data-vid-id="{{feature._id}}" data-vid-vidid="{{feature.additional_properties.videoId}}" data-vid-url="{{feature.promo_image.url}}">
               <img contenteditable="false" src="{{feature.promo_image.url}}" alt="{{feature.promo_image._id}}">
               <div data-update-text="true" contenteditable="false" class="info-bar py-3">
                 <i class="fa fa-video-camera"></i> ${intl.get(
                   'blocks.video.videoLabel'
                 )} &nbsp;|&nbsp <strong>${intl.get(
    'blocks.image.subtitleLabel'
  )}:</strong> &quot;{{feature.headlines.basic || feature.title }}&quot;
 
                 <span ng-show="!feature.additional_properties.published" class="ng-hide pull-right unpublished"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${intl.get(
                   'blocks.image.unpublishedBadge'
                 )}</span>
 
                 <span ng-show="feature.additional_properties.published" class="ng-hide pull-right published">${intl.get(
                   'blocks.image.publishedBadge'
                 )}</span>
 
                 <div ng-if="feature.subheadlines.basic">
                   <strong>${intl.get(
                     'blocks.video.blurbLabel'
                   )}:</strong> {{feature.subheadlines.basic}}
                 </div>
 
                 <div ng-if="feature.description.basic">
                   <strong>${intl.get(
                     'blocks.video.teaseLabel'
                   )}:</strong> {{feature.description.basic}}
                 </div>
                 <div class="mt-1">
                   <button type="button" class="btn btn-primary btn-sm " ng-click="showPropModal(index)" title=${intl.get(
                     'blocks.image.buttons.edit'
                   )}>${intl.get('blocks.image.buttons.edit')}</button>
                 </div>
               </div>
             </figure>`,
  propertyTemplate: `
      <div class="form-group row" ng-if="$root.globalSettingsModel.mediaOptions.video.showTitle">
        <label>Title</label>
        <textarea
          rows="5"
          smart-quote-handler
          class="form-control"
          ng-model="feature.headlines.basic"
          ng-change="feature.referent_properties.headlines = feature.referent_properties.headlines || {}; feature.referent_properties.headlines.basic = feature.headlines.basic"></textarea>
      </div>
      <div class="form-group row" ng-if="$root.globalSettingsModel.mediaOptions.video.showBlurb">
        <label>Blurb</label>
        <textarea
          rows="5"
          smart-quote-handler
          class="form-control"
          ng-model="feature.subheadlines.basic"
          ng-change="feature.referent_properties.subheadlines = feature.referent_properties.subheadlines || {}; feature.referent_properties.subheadlines.basic = feature.subheadlines.basic"></textarea>
      </div>
      <div class="form-group row" ng-if="$root.globalSettingsModel.mediaOptions.video.showTease">
        <label>Tease</label>
        <textarea
          rows="10"
          smart-quote-handler
          class="form-control"
          ng-model="feature.description.basic"
          ng-change="feature.referent_properties.description = feature.referent_properties.description || {}; feature.referent_properties.description.basic = feature.description.basic"></textarea>
      </div>
      <div class="row" ng-if="$root.globalSettingsModel.mediaOptions.noVideoFields">
        <p>No fields to edit, see 'Media Options' in settings to configure</p>
      </div>
    `,
  preview: function (feature) {
    const videoId = feature.additional_properties.videoId
    if (videoId) {
      window.open('/goldfish/video/v2/#/clip/' + videoId)
    }
  },
}
